import { useEffect, useState } from "react";
import {
  useLazyGetEstudianteByIdQuery,
  useGetEstadoPorEstudianteQuery,
} from "services";
import { telefonoIcon } from "examples/TelefonosCRUD/telefonos.add";

export const useStudentFetch = (id, setFieldValue, formField) => {
  const [oldValues, setOldValues] = useState();
  const [estadoIdState, setEstadoIdState] = useState();

  const [getEstudianteById, { data: estudiante }] =
    useLazyGetEstudianteByIdQuery();

  const { data: estado } = useGetEstadoPorEstudianteQuery(
    {
      filter_params: {
        estudiante: id,
        query: "{estado, id}",
      },
      shape: {
        id: "id",
        estado: "estado",
      },
    },
    {
      refetchOnReconnect: true,
      skip: !id,
    },
  );

  useEffect(() => {
    if (id) {
      getEstudianteById({
        id: id,
        filter_params: {
          query:
            "{user{first_name,apellido_materno,apellido_paterno,email,foto},url,curp,telefonos,numero_de_control,genero{url},tipo_sangre,preasignacion_de_carrera{url},usuario_wifi,password_wifi}",
        },
      })
        .unwrap()
        .then((res) => {
          setOldValues((prevState) => ({
            ...prevState,
            nombre: res?.user.first_name,
            apellido_materno: res?.user.apellido_materno,
            apellido_paterno: res?.user.apellido_paterno,
            curp: res?.curp,
            telefonos:
              res?.telefonos?.map((el) => ({
                ...el,
                isCreated: false,
                icon: telefonoIcon(el.tipo),
              })) || [],
            numero_de_control: res?.numero_de_control,
            genero: res?.genero.url,
            tipo_sangre: res?.tipo_sangre,
            foto: res?.user.foto,
            preasignacion_de_carrera: res?.preasignacion_de_carrera?.url ?? "",
            ciclo: "",
            usuario_wifi: res?.usuario_wifi,
            password_wifi: res?.password_wifi,
          }));

          setFieldValue(formField.nombre.name, res?.user.first_name, true);
          setFieldValue(
            formField.apellido_paterno.name,
            res?.user.apellido_paterno,
            true,
          );
          setFieldValue(
            formField.telefonos.name,
            res?.telefonos?.map((el) => ({
              ...el,
              isCreated: false,
              icon: telefonoIcon(el.tipo),
            })) || [],
            true,
          );
          setFieldValue(
            formField.apellido_materno.name,
            res?.user.apellido_materno,
            true,
          );
          setFieldValue(
            formField.numero_de_control.name,
            res?.numero_de_control,
            true,
          );
          setFieldValue(formField.foto.name, res?.user.foto, true);
          setFieldValue(formField.genero.name, res?.genero.url, true);
          setFieldValue(
            formField.preasignacion_de_carrera?.name,
            res?.preasignacion_de_carrera?.url ?? "",
            true,
          );
          setFieldValue(formField.tipo_sangre.name, res?.tipo_sangre, true);
          setFieldValue(formField.curp.name, res?.curp, true);
          setFieldValue(formField.usuario_wifi.name, res?.usuario_wifi, true);
          setFieldValue(formField.password_wifi.name, res?.password_wifi, true);
        });
    }
  }, [id, getEstudianteById, setFieldValue, formField]);

  useEffect(() => {
    if (Array.isArray(estado) && estado.length !== 0) {
      setFieldValue(formField.estado.name, estado[estado.length - 1].estado);
      setEstadoIdState(estado[estado.length - 1].id);
      setOldValues((prevState) => ({
        ...prevState,
        estado: estado[estado.length - 1].estado,
      }));
    }
  }, [estado, setFieldValue, formField]);

  return { oldValues, estado, estadoIdState, estudiante, getEstudianteById };
};
